import { render, staticRenderFns } from "./WhatsNext.vue?vue&type=template&id=eaebd372&scoped=true&"
import script from "./WhatsNext.vue?vue&type=script&lang=js&"
export * from "./WhatsNext.vue?vue&type=script&lang=js&"
import style0 from "./WhatsNext.vue?vue&type=style&index=0&id=eaebd372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaebd372",
  null
  
)

export default component.exports